interface TextStyleConfig {
  fontSize?: string | Record<string, string>;
  lineHeight?: string | Record<string, string>;
  fontWeight?: number | string;
  color?: string;
  fontFamily?: string;
}

interface TextStyles {
  [key: string]: TextStyleConfig;
}

const textStyles: TextStyles = {
  h1: {
    fontSize: { base: '45px', lg: '80px' },
    lineHeight: { base: '150%', lg: '130%' },
    fontWeight: 600,
  },
  // 一般的標題
  h2: {
    fontSize: { base: '40px', lg: '60px' },
    lineHeight: { base: '150%', lg: '150%' },
    fontWeight: 700,
    color: 'cloud.500',
  },
  h3: {
    fontSize: { base: '32px', lg: '34px' },
    lineHeight: { base: '150%', lg: '150%' },
    fontWeight: 700,
  },
  h4: {
    fontSize: { base: '20px', lg: '20px' },
    lineHeight: { base: '150%', lg: '150%' },
    fontWeight: 700,
    color: 'primary-text-color',
  },
  h5: {
    fontSize: { base: '16px', lg: '18px' },
    lineHeight: { base: '100%', lg: '100%' },
    fontWeight: 700,
    color: 'primary-text-color',
  },
  h6: {
    fontSize: { base: '14px', lg: '18px' },
    lineHeight: { base: '100%', lg: '100%' },
    fontWeight: 700,
    color: 'primary-text-color',
  },
  p1: {
    fontSize: { base: '18px', lg: '24px' },
    lineHeight: { base: '150%', lg: '150%' },
    fontWeight: 400,
  },
  p2: {
    fontSize: { base: '16px', lg: '18px' },
    lineHeight: { base: '150%', lg: '150%' },
    fontWeight: 400,
    color: 'primary-text-color',
  },
  p3: {
    fontSize: { base: '14px', lg: '14px' },
    lineHeight: '150%',
    fontWeight: 400,
  },
  p4: {
    fontSize: { base: '12px', lg: '12px' },
    lineHeight: '150%',
    fontWeight: 400,
  },
  content01: {
    fontSize: { base: '20px', lg: '28px' },
    lineHeight: '150%',
    fontWeight: 300,
    color: 'text-title',
    fontFamily: 'roboto,Roboto,system-ui,PingFang TC,Noto Sans TC,Heiti TC,sans-serif',
  },
  content02: {
    fontSize: { base: '14px', lg: '20px' },
    lineHeight: '150%',
    fontWeight: 400,
    color: 'text-title',
    fontFamily: 'roboto,Roboto,system-ui,PingFang TC,Noto Sans TC,Heiti TC,sans-serif',
  },
  content03: {
    fontSize: { base: '14px', lg: '14px' },
    lineHeight: '150%',
    fontWeight: 400,
    color: 'text-title',
    fontFamily: 'roboto,Roboto,system-ui,PingFang TC,Noto Sans TC,Heiti TC,sans-serif',
  },
  text01: {
    fontSize: { base: '20px', lg: '20px' },
    lineHeight: '150%',
    fontFamily: 'roboto,Roboto,system-ui,PingFang TC,Noto Sans TC,Heiti TC,sans-serif',
  },
  text02: {
    fontSize: { base: '14px', lg: '14px' },
    lineHeight: '150%',
    fontFamily: 'roboto,Roboto,system-ui,PingFang TC,Noto Sans TC,Heiti TC,sans-serif',
  },
  price: {
    fontFamily: 'SF Pro,system-ui',
  },
  //特別
  specialLg: {
    fontSize: { base: '60px', lg: '140px' },
    fontWeight: 700,
  },
  // design system 的字體設計
  p12: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
  },
  p14: {
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 400,
  },
  p16: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
  },
  p20: {
    fontSize: '20px',
    lineHeight: '28px',
    fontWeight: 400,
  },
  h14: {
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 700,
  },
  h16: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 700,
  },
  h20: {
    fontSize: '20px',
    lineHeight: '28px',
    fontWeight: 700,
  },
  h24: {
    fontSize: '24px',
    lineHeight: '32px',
    fontWeight: 700,
  },
  h32: {
    fontSize: '32px',
    lineHeight: '40px',
    fontWeight: 700,
  },
};

export default textStyles;
